import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
let CmsService = class CmsService {
    constructor(cmsApi) {
        this.cmsApi = cmsApi;
        this.getBasicList = this.cmsApi.getBasicList;
        this.getModelList = this.cmsApi.getModelList;
        this.putAddModelItem = this.cmsApi.putAddModelItem;
        this.deleteModelItem = this.cmsApi.deleteModelItem;
        this.postGetConfigList = this.cmsApi.postGetConfigList;
        this.putImportConfig = this.cmsApi.putImportConfig;
        this.deleteConfig = this.cmsApi.deleteConfig;
        this.getConfigDetail = this.cmsApi.getConfigDetail;
        this.putAddConfigDetail = this.cmsApi.putAddConfigDetail;
        this.putUpdateConfig = this.cmsApi.putUpdateConfig;
    }
};
CmsService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CmsApi)),
    __metadata("design:paramtypes", [Object])
], CmsService);
export { CmsService };
